import { render, staticRenderFns } from "./SettingsTopNav.vue?vue&type=template&id=ddf6092a"
import script from "./SettingsTopNav.vue?vue&type=script&lang=js"
export * from "./SettingsTopNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports